import { Component, OnInit } from '@angular/core';
import { AuthService, User } from '../services/auth.service';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html'
})
export class LogoutComponent {
  currentUser: User;

  constructor(private authService: AuthService) {
    this.authService.getUser().subscribe((u) => {
      this.currentUser = u;
    });
  }

  public isIngelogd(): boolean {
    if (!!this.currentUser && !!this.currentUser.access_token) {
      return true;
    } else {
      return false;
    }
  }

  public naam(): string {
    if (
      !!this.currentUser &&
      !!this.currentUser.profile &&
      !!this.currentUser.profile['name']
    ) {
      return this.currentUser.profile['name'];
    } else {
      return 'Onbekend';
    }
  }

  login() {
    this.authService.login();
  }

  logout() {
    this.authService.logout();
  }
}
